// Generated by purs version 0.15.0
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Map_Ordered from "../Data.Map.Ordered/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ratio from "../Data.Ratio/index.js";
import * as Data_Rational_Serialized from "../Data.Rational.Serialized/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Data_Unfoldable1 from "../Data.Unfoldable1/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_PackagingContainer from "../Restaumatic.Menu.V2.Types.PackagingContainer/index.js";
import * as Restaumatic_Menu_V2_Types_ProductCategory from "../Restaumatic.Menu.V2.Types.ProductCategory/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var Container = /* #__PURE__ */ (function () {
    function Container(value0) {
        this.value0 = value0;
    };
    Container.create = function (value0) {
        return new Container(value0);
    };
    return Container;
})();
var Contained = function (x) {
    return x;
};
var showContainer = function (dictShow) {
    return {
        show: function (v) {
            return Data_Show.show(dictShow)(v.value0.details) + (": " + Data_Show.show(Data_Ratio.showRatio(Data_Show.showInt))(v.value0.capacity));
        }
    };
};
var showContained = function (dictShow) {
    return {
        show: function (v) {
            return Data_Show.show(Data_Ratio.showRatio(Data_Show.showInt))(v.volume) + (" in [" + (Data_Foldable.intercalate(Data_Foldable.foldableArray)(Data_Monoid.monoidString)(", ")(Data_Functor.map(Data_Functor.functorArray)(Data_Show.show(showContainer(dictShow)))(v.allowedContainers)) + "]"));
        }
    };
};
var packEachProductToItsFirstAllowedContainer = function (dictOrd) {
    return function (containeds) {
        return Data_Array.mapMaybe(function (v) {
            return Data_Functor.map(Data_Maybe.functorMaybe)(function (container) {
                return new Data_Tuple.Tuple(container, containeds);
            })(Data_Array.head(v.allowedContainers));
        })(containeds);
    };
};
var mergePackagingContainersConfig = function (x) {
    return function (y) {
        return {
            volume: Data_Ord.max(Data_Rational_Serialized.ordRational)(Data_Record.getField(Restaumatic_Menu_V2_Types_PackagingContainer.hasFieldPackagingContaine1(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "volume";
                }
            })()))(Type_Proxy["Proxy"].value)(x))(Data_Record.getField(Restaumatic_Menu_V2_Types_PackagingContainer.hasFieldPackagingContaine1(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "volume";
                }
            })()))(Type_Proxy["Proxy"].value)(y)),
            allowedContainers: Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Set.intersection(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Data_Set.fromFoldable(Data_Foldable.foldableArray)(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Data_Record.getField(Restaumatic_Menu_V2_Types_PackagingContainer.hasFieldPackagingContaine1(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "allowedContainers";
                }
            })()))(Type_Proxy["Proxy"].value)(x)))(Data_Set.fromFoldable(Data_Foldable.foldableArray)(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Data_Record.getField(Restaumatic_Menu_V2_Types_PackagingContainer.hasFieldPackagingContaine1(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "allowedContainers";
                }
            })()))(Type_Proxy["Proxy"].value)(y))))
        };
    };
};
var mergeMaybePackagingContainersConfig = function (v) {
    return function (v1) {
        if (v instanceof Data_Maybe.Nothing) {
            return v1;
        };
        if (v1 instanceof Data_Maybe.Nothing) {
            return v;
        };
        if (v instanceof Data_Maybe.Just && v1 instanceof Data_Maybe.Just) {
            return new Data_Maybe.Just(mergePackagingContainersConfig(v.value0)(v1.value0));
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Packaging (line 128, column 1 - line 128, column 141): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var eqContainer = function (dictEq) {
    return {
        eq: function (v) {
            return function (v1) {
                return Data_Eq.eq(dictEq)(v.value0.details)(v1.value0.details);
            };
        }
    };
};
var ordContainer = function (dictOrd) {
    return {
        compare: function (v) {
            return function (v1) {
                return Data_Ord.compare(dictOrd)(v.value0.details)(v1.value0.details);
            };
        },
        Eq0: function () {
            return eqContainer(dictOrd.Eq0());
        }
    };
};
var eqContained = function (dictEq) {
    return {
        eq: function (v) {
            return function (v1) {
                return Data_Eq.eq(Data_Ratio.eqRatio(Data_Eq.eqInt))(v.volume)(v1.volume) && Data_Eq.eq(Data_Eq.eqArray(eqContainer(dictEq)))(v.allowedContainers)(v1.allowedContainers);
            };
        }
    };
};
var computePackagingContainers = function (categories) {
    return function (packagingContainers) {
        return function (productsCatalogue) {
            return function (modifiersCatalogue) {
                return function (algo) {
                    var containedsToPackaging = function (containers) {
                        var price = Data_Numeric.sum(Data_Foldable.foldableArray)(Data_Money_Rounded.additiveMoney)(Data_Functor.map(Data_Functor.functorArray)(Data_Functor.map(Data_Functor.functorFn)(function (v) {
                            return v.value0.price;
                        })(Data_Tuple.fst))(containers));
                        var containerIdToContainedsMapping = Data_Functor.mapFlipped(Data_Functor.functorArray)(containers)(function (v) {
                            return new Data_Tuple.Tuple(v.value0.value0.details, v.value1);
                        });
                        return new Data_Tuple.Tuple(containerIdToContainedsMapping, price);
                    };
                    var contained = function (containedId) {
                        return function (v) {
                            var container = function (v1) {
                                return function (v2) {
                                    if (v2.enabled) {
                                        return new Data_Maybe.Just(new Container({
                                            details: v1,
                                            capacity: Data_Newtype.unwrap()(v2.capacity),
                                            price: v2.price
                                        }));
                                    };
                                    return Data_Maybe.Nothing.value;
                                };
                            };
                            return {
                                allowedContainers: Data_Array.mapMaybe(function (containerId) {
                                    return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(containerId)(packagingContainers))(container(containerId));
                                })(v.allowedContainers),
                                volume: Data_Newtype.unwrap()(v.volume),
                                containedId: containedId
                            };
                        };
                    };
                    var packagedsToContaineds = function (packageds) {
                        var packagedToContaineds = function (v) {
                            var containedsOfProducts = function (ids) {
                                var productContainersConfig = function (v1) {
                                    if (v1.packagingContainersConfigOverride instanceof Data_Maybe.Just) {
                                        return new Data_Maybe.Just(v1.packagingContainersConfigOverride.value0);
                                    };
                                    if (v1.packagingContainersConfigOverride instanceof Data_Maybe.Nothing) {
                                        return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(v1.category)(categories))(function (v2) {
                                            return Data_Record.getField(Restaumatic_Menu_V2_Types_ProductCategory.hasFieldProductCategory(Data_Record.hasFieldRecord({
                                                reflectSymbol: function () {
                                                    return "packagingContainersConfig";
                                                }
                                            })()))(Type_Proxy["Proxy"].value)(v2);
                                        });
                                    };
                                    throw new Error("Failed pattern match at Restaumatic.Menu.V2.Packaging (line 94, column 9 - line 94, column 78): " + [ v1.constructor.name ]);
                                };
                                return Data_Maybe.maybe([  ])((function () {
                                    var $98 = Data_Unfoldable1.singleton(Data_Unfoldable1.unfoldable1Array);
                                    var $99 = contained(new Restaumatic_Menu_V2_Types_PackagingContainer.ProductId(ids));
                                    return function ($100) {
                                        return $98($99($100));
                                    };
                                })())(Data_Foldable.foldr(Data_Foldable.foldableArray)(mergeMaybePackagingContainersConfig)(Data_Maybe.Nothing.value)(Data_Functor.map(Data_Functor.functorArray)(function (id) {
                                    return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(id)(productsCatalogue))(productContainersConfig);
                                })(ids)));
                            };
                            var containedsOfModifiers = function (ids) {
                                var containedOfModifier = function (v1) {
                                    var v2 = Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(v1.modifier)(modifiersCatalogue);
                                    var v3 = Control_Bind.bind(Data_Maybe.bindMaybe)(v2)(function (v4) {
                                        return Data_Array.head(Data_Array.mapMaybe(function (v5) {
                                            return Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(v1.modifierItem)(Data_Map_Ordered.toMap(v5.items));
                                        })(v4.sections));
                                    });
                                    var v4 = Control_Bind.bind(Data_Maybe.bindMaybe)(v3)(function (v5) {
                                        return v5.packagingContainersConfig;
                                    });
                                    return Data_Functor.map(Data_Maybe.functorMaybe)(contained(new Restaumatic_Menu_V2_Types_PackagingContainer.ModifierItemId(v1.modifier, v1.modifierItem)))(v4);
                                };
                                return Data_Array.mapMaybe(containedOfModifier)(ids);
                            };
                            return Data_Semigroup.append(Data_Semigroup.semigroupArray)(containedsOfProducts(v.products))(containedsOfModifiers(v.modifiers));
                        };
                        return Control_Bind.bind(Control_Bind.bindArray)(packageds)(packagedToContaineds);
                    };
                    var $101 = algo(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId);
                    return function ($102) {
                        return containedsToPackaging($101(packagedsToContaineds($102)));
                    };
                };
            };
        };
    };
};
export {
    Container,
    Contained,
    computePackagingContainers,
    packEachProductToItsFirstAllowedContainer,
    mergePackagingContainersConfig,
    mergeMaybePackagingContainersConfig,
    eqContainer,
    ordContainer,
    showContainer,
    showContained,
    eqContained
};
//# sourceMappingURL=index.js.map
